import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const ErrorIcon = () => {
  return <ErrorOutlineIcon />;
};
